import {useSelector} from "react-redux";
import store from "../../redux/store";
import {VATs} from "../../redux/settingsSlice";

export function filterJobs(jobs) {
    return jobs.filter(job => filterJob(job));
}

export function filterDetailsFromJobs(jobs, validOnly = true) {
    const fluidsIds = [2, 3, 4, 5, 6, 8];
    const details = [];

    jobs.forEach((job, index) => {
        if(job.repair_tips) return;
        if (filterJob(job)) {
            const isFluid = fluidsIds.indexOf(job.operation.operation_id) !== -1;
            const isValid = filterDetail(job);

            if (!job.detail.hidden && (isValid || !validOnly)) {
                if (isFluid || job.detail.detailOnly) {
                    details.push({job: job, jobIndex: index});
                }
            }
        }
    });
    return details;
}

export function filterJob(job) {
    if (job.job_id === null && !job.detail.detailOnly) {
        return isValidJob(job);
    }
    return true;
}

export function filterDetail(job) {
    if (job.job_id === null && job.detail.detailOnly) {
        return isValidDetail(job);
    }
    return true;
}

export function isValidJob(job) {
    if (job.detail.part_id === null && job.detail.part_name === '') {
        return false;
    }
    if (job.operation.operation_id === null && job.operation.operation_name === '') {
        return false;
    }
    if (job.detail.part_id === null && (!job?.system?.system_id || !job?.superSystem?.super_system_id)) {
        return false;
    }
    if (job?.sdh_hour <= 0) {
        return false;
    }
    return true;
}

export function isValidDetail(job) {
    if (job.detail.part_id === null && job.detail.part_name === '') {
        return false;
    }
    return true;
}

export function jobsHoursSum() {
    const jobs = store.getState().jobs.jobs;
    const validJobs = filterJobs(jobs);

    const sum = Math.round(validJobs.reduce((sum, item) => sum + Number(item.sdh_hour), 0) * 100) / 100

    return sum;
}

export function jobsFinalSum(options = {useVat: false}) {
    const state = store.getState();

    const jobs = state.jobs.jobs;
    const jobsVat = state.settings.vats[VATs.jobs];
    const validJobs = filterJobs(jobs);

    let sum = validJobs.reduce((sum, item) => {
        return sum + (item?.repair_tips ? 0 : Math.round(item.sdh_hour * item.hourPrice * item.difficulty * 100) / 100);
    }, 0);

    if (options.useVat) { // Для всех jobs (услуг) одно значение НДС
        sum = sumWithVAT(sum, jobsVat);
    }
    return sum;
}

export function jobsFinalVat() {
    const jobsVat = store.getState().settings.vats[VATs.jobs];

    return vatFromSum(jobsFinalSum(), jobsVat);
}

export function detailsAmountSum() {
    const jobs = store.getState().jobs.jobs;
    const details = filterDetailsFromJobs(jobs);

    const sum = details.reduce((sum, item) => {
        if (item.job.detail.amount) {
            return sum + Number(item.job.detail.amount);
        } else {
            return sum;
        }
    }, 0);

    return sum;
}

export function detailsFinalSum(options = {useVat: false}) {
    const state = store.getState();

    const jobs = state.jobs.jobs;
    const details = filterDetailsFromJobs(jobs);

    const sum = details.reduce((sum, item) => {
        return sum + detailSum(item.job.detail, options);
    }, 0);

    return sum;
}

export function detailsFinalVat() {
    const state = store.getState();

    const jobs = state.jobs.jobs;
    const details = filterDetailsFromJobs(jobs);

    const sum = details.reduce((sum, item) => {
        const partSum = detailSum(item.job.detail);

        return sum + vatFromSum(partSum, detailVat(item.job.detail));
    }, 0);

    return sum;
}

export function detailSum(detail, options = {useVat: false}) {
    const hasPrice = detail.amount && detail.price;
    if (!hasPrice) {
        return 0;
    }
    let sum = Math.round(detail.amount * detail.price * 100) / 100;
    if (options.useVat) {
        sum = sumWithVAT(sum, detailVat(detail));
    }
    return sum;
}

export function detailVat(detail) {
    const partsVat = store.getState().settings.vats[VATs.parts];
    const customValue = detail.custom_vat_value;

    const vat = {...partsVat};

    if (customValue !== null && customValue !== undefined) {
        vat.value = Number(customValue);
    }
    return vat;
}

export function vatString({active, type, value}) {
    const _type = active ? type + 1 : 0;
    switch (_type) {
        case 1:
        case 2:
            return `${value}%`;
        default:
            return '';
    }
}

export function vatFromSum(sum, {active, type, value}) {
    const _type = active ? type + 1 : 0;
    const sum100 = Math.round(Number(sum) * 100);
    let value100 = 0;

    if (_type === 1) { // НДС в сумме
        value100 = Math.round(sum100 * value / (value + 100));
    }
    if (_type === 2) { // НДС сверху
        value100 = Math.round(sum100 * (value + 100) / 100) - sum100;
    }
    return value100 / 100;
}

export function sumWithVAT(sum, {active, type, value}) {
    const _type = active ? type + 1 : 0;
    switch (_type) {
        case 2:
            return sum + vatFromSum(sum, {active, type, value});
        default:
            return sum;
    }
}